<div class="row" style="margin: 0px!important;">
    <div class="col-sm-12">
        <mat-card id="heigthChild"> 
            <mat-card-content>
                <div id="cycleBcs">
                    <div *ngIf="cycles && cycles.length !== 0"  class="my-row">
                        <div class="row">
                            <div class="col-sm-12">
                                <span style="font-weight: bold;">{{title}}
                                </span>
                            </div>
                        </div>
                        <div class="row flex" style="width: 100%;" *ngFor="let item of getSortedArrayByDate(); let fst = first;let lst = last;">
                            <div>
                                <span [style.color]="getStyle(item.fLitige)"> {{item.dAction| date:'dd/MM/yyyy'}}</span>
                            </div>
                            <div>
                                <span matTooltip="{{item.user.prenom}} {{item.user.nom}}" [style.color]="getStyle(item.fLitige)"> 
                                    {{item.user.prenom.substring(0,1).toUpperCase()+item.user.nom.substring(0,2).toUpperCase()}}
                                </span>
                            </div>
                            <div *ngIf="item.libelle">
                                <mat-icon matTooltip="{{item.libelle}}"> format_quote</mat-icon> 
                            </div>

                            <div class="content" *ngIf="fst">
                                <span *ngIf="item.libelle.length > 1">{{item.libelle}}</span>
                            </div>
                            <div   *ngIf="!lst" class="col-sm-12" style=" text-align: center !important;">
                                <mat-icon *ngIf="!item.bRetour" style="color: green;">arrow_upward
                                </mat-icon>
                                <mat-icon *ngIf="item.bRetour" style="color:orange;">arrow_upward
                                </mat-icon>
                            </div>
                        </div>
                    </div>
                </div>
               
            </mat-card-content>
        </mat-card>
    </div>
</div>